import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import { Link } from "react-router-dom";
import { SectionHeader } from "./../Blocks.js";
import Section from "./Section.js";
import { color } from "./../style/Variables.js";
import IMG_PATTERN from "./photos/TrueLens-Pattern8.png";

import IMG_TAGES from "./photos/Product-Tageslinsen.jpg";
import IMG_MONATS from "./photos/Product-Monatslinsen.jpg";

import { injectGlobal } from "styled-components";

injectGlobal`
  .product-variant {
    color: ${color.battleship_grey};

    &-visible {
      color: ${color.black};

      span {
        border-bottom: 1px solid ${color.tealish_two};
      }
    }
  }
  .product-description {
    opacity: 0;
    /* transition: opacity .4s ease; */
    position: absolute;
    pointer-events: none;

    &-visible {
      position: inherit;
      opacity: 1;
      pointer-events: initial;
    }
  }
`;

const handleClick = e => {
  const index = e.target.getAttribute("data-type") === "tage" ? 0 : 1;

  const variant = document.querySelectorAll(
    ".product-variant.product-variant-visible"
  );

  const description = document.querySelectorAll(".product-description-visible");

  const variantAttr = document.getElementsByClassName(
    e.target.getAttribute("data-variant")
  );

  variant[index].classList.toggle("product-variant-visible");

  e.target.parentNode.classList.toggle("product-variant-visible");

  if (document.querySelectorAll(".product-description-visible")[index]) {
    description[index].classList.toggle("product-description-visible");
  }

  variantAttr[index].classList.toggle("product-description-visible");
};

const ProductImage = p => <img className="fit mb3" alt="" {...p} />;

const ProductTitle = p => (
  <h3 className="h4 font-regular color-navy center mt2 mb2">{p.children}</h3>
);

const ProductSubline = p => (
  <h4 className="body-large font-light color-bg center mt2 mb2 pb1 line-height-4">
    {p.children}
  </h4>
);

const ProductVariant = p => (
  <div
    className={`mb2 mt1 mmb0 pointer product-variant caps ${
      p.index === 0 ? "product-variant-visible" : ""
    }`}
    // data-variant={p.children.toLowerCase()}
  >
    <span
      className="inline-block pb1 letter-spacing-2 mx2 mmx0-4"
      data-variant={p.children.toLowerCase()}
      onClick={handleClick}
      data-type={p.type}
      style={{ fontSize: "0.8125rem" }}
    >
      {p.children}
    </span>
  </div>
);

const ProductDesc = p => (
  <p
    className={`product-description center font-light line-height-5 color-bg w-80 ${p.children.title.toLowerCase()} ${
      p.index === 0 ? "product-description-visible" : ""
    }`}
  >
    {p.children.description}
  </p>
);

// const TryButton = p => (
//   <p className="center mt1">
//     <a
//       href={p.href || ""}
//       target="_blank"
//       style={{ fontSize: "14px" }}
//       className="h6 caps color-turquoise font-regular hover-color-lt"
//     >
//       {p.children}
//     </a>
//   </p>
// );

const BuyButton = p => (
  <p className="center mt1">
    <a href={p.href || ""} target="_blank" className="btn">
      {p.children}
    </a>
  </p>
);

const Product = p => {
  const variantsList = p.variants ? Object.keys(p.variants) : [];

  return (
    <Col md={6} lg={5} offset={{ md: 3, lg: 0.65 }} className="center mb4">
      <ProductImage src={p.img || ""} />
      <ProductTitle>{p.title}</ProductTitle>
      <ProductSubline>{p.description}</ProductSubline>

      <Row className="pmt1 bg-m-wf" style={{ justifyContent: "center" }}>
        {variantsList.map((k, i) => {
          return (
            <ProductVariant
              key={i}
              type={variantsList.length === 3 ? "tage" : "monat"}
              index={i}
            >
              {p.variants[k].title}
            </ProductVariant>
          );
        })}
      </Row>

      <Row
        style={
          window.innerWidth >= 900
            ? {
                justifyContent: "center",
                height: "194px", //setting height < min-height fixes alignItems for IE, lol
                minHeight: "195px",
                alignItems: "center",
                width: "calc(100% + 30px)",
              }
            : {
                justifyContent: "center",
                height: "229px", //setting height < min-height fixes alignItems for IE, lol
                minHeight: "230px",
                alignItems: "center",
                width: "calc(100% + 30px)",
              }
        }
        className="w-100 bg-wf py3 px3 mb2 mt2 mx4 mmx0 mmt0"
      >
        {variantsList.map((k, i) => {
          return (
            <ProductDesc key={i} index={i}>
              {p.variants[k]}
            </ProductDesc>
          );
        })}
      </Row>
      <BuyButton href={p.buyURL}>{p.buy}</BuyButton>
      {/* <TryButton href={p.tryURL}>{p.try}</TryButton> */}
    </Col>
  );
};

const SectionProduct = (props, context) => {
  const copy = context.copy.get("SectionProduct");

  return (
    <Section id="products" className="section-product">
      <Container className="my3">
        <Row>
          <Col className="my3 pmx0i">
            <SectionHeader>{copy && copy.title}</SectionHeader>
          </Col>
        </Row>
        <Row>
          <Product
            img={IMG_TAGES}
            width="460"
            title={copy && copy.products[0].title}
            description={copy && copy.products[0].description}
            try={copy && copy.products[0].try}
            tryURL={copy && copy.products[0].tryURL}
            buy={copy && copy.products[0].buy}
            buyURL={copy && copy.products[0].buyURL}
            variants={copy && copy.products[0].variants}
          />
          <Product
            img={IMG_MONATS}
            width="460"
            title={copy && copy.products[1].title}
            description={copy && copy.products[1].description}
            try={copy && copy.products[1].try}
            tryURL={copy && copy.products[1].tryURL}
            buy={copy && copy.products[1].buy}
            buyURL={copy && copy.products[1].buyURL}
            variants={copy && copy.products[1].variants}
          />
        </Row>
      </Container>
      <Container
        fluid
        className="bg-ib my4 mmb3 mmtn1"
        style={
          window.innerWidth >= 900
            ? {
                backgroundImage: `url(${IMG_PATTERN})`,
                backgroundRepeat: `no-repeat`,
                backgroundPosition: `50% 50%`,
                backgroundSize: `100% 100%`,
              }
            : {
                backgroundImage: `url(${IMG_PATTERN})`,
                backgroundRepeat: `no-repeat`,
                backgroundPosition: `50% 50%`,
                backgroundSize: `100% 100%`,
                marginLeft: "-15px",
                width: "calc(100% + 30px)",
              }
        }
      >
        <Row className="py4 pmx0i pmy2">
          <Col lg={8} offset={{ lg: 2 }} className="center line-height-4 pmx0i">
            <h3 className="h3 mt4 mb3 center color-tb font-light">
              {copy && copy.wizard_title}
            </h3>
            <Link
              className="btn mt2 mb4 line-height-4"
              to={`/${props.match.params.locale}/wizard`}
            >
              {copy && copy.wizard_cta}
            </Link>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};
SectionProduct.contextTypes = { copy: PropTypes.object };

export default SectionProduct;



// WEBPACK FOOTER //
// ./src/Home/SectionProduct.js